/**
 * Copy of `values` sorted by localeCompare on a resolved key per item.
 * Uses numeric + base options; when `resolveKey` is nullish, the raw value is used as the key.
 */
export function sortStringsByResolvedLocaleKey(
  values: string[],
  resolveKey: (value: string) => string | null | undefined,
): string[] {
  return [...values].sort((a, b) => {
    const keyA = resolveKey(a) ?? a
    const keyB = resolveKey(b) ?? b
    return keyA.localeCompare(keyB, undefined, { numeric: true, sensitivity: 'base' })
  })
}
